import { processAPIResponse } from '@/utils/request';
import { fetchTaskAutomationMetaRequest, fetchTaskAutomationsList } from '@/services/api/taskAutomation';
import * as TaskAutomationSelectors from '@/selectors/taskAutomationSelectors';

const initialState = {
  visible: false,
  currentAutomation: null,
  list: [],
  meta: null,
  loading: false,
  error: null,
};

export default {
  namespace: 'taskAutomation',

  state: initialState,

  effects: {
    * fetch({ payload }, { call, put }) {
      const { response, data } = yield call(fetchTaskAutomationsList, {
        query: payload?.query || {},
      });
      yield processAPIResponse({ response, data }, {
        * onSuccess(data) {
          yield put({
            type: 'saveTaskAutomations',
            payload: data?.map(taskAutomation => ({
              ...taskAutomation,
              is_active: taskAutomation.is_active != 0,
            })),
          });
        },
      }, 'data');
    },
    // The details metadata is static per session — fetch once, on first editor open
    * fetchMeta(_, { call, put, select }) {
      const existing = yield select(TaskAutomationSelectors.selectTaskAutomationMeta);
      if (existing) return;
      const { response, data } = yield call(fetchTaskAutomationMetaRequest);
      yield processAPIResponse({ response, data }, {
        * onSuccess(meta) {
          yield put({
            type: 'saveMeta',
            payload: meta,
          });
        },
      }, 'data');
    },
  },

  reducers: {
    saveMeta(state, action) {
      return {
        ...state,
        meta: action.payload || null,
      };
    },
    saveTaskAutomations(state, action) {
      return {
        ...state,
        list: action.payload,
        error: null,
      };
    },
    toggle(state) {
      return {
        ...state,
        visible: !state.visible,
        currentAutomation: null,
      }
    },
    open(state, action) {
      return {
        ...state,
        visible: true,
        currentAutomation: action?.payload?.taskAutomation || null,
      };
    },
    close(state) {
      return {
        ...state,
        visible: false,
        currentAutomation: null,
      };
    },
    reset() {
      return initialState;
    },
  },
};
